import React from "react";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import TypographyComponent from "../../../components/Typography/ThypographyComponent";

interface ButtonFilterPedidoProps {
    id: string;
    label: string;
    value: string;
    count: number;
    color: string;
    backgroundColor: string;
    borderColor: string;
    onClick: (value: string) => void;
    disabled?: boolean
}

const ButtonFilterPedidoComponent = (props: ButtonFilterPedidoProps) => {
    return <ButtonComponent
        id={props.id}
        sx={{
            height: 36,
            opacity: 1,
            transform: 'rotate(0deg)',

            // Espaçamento (Vertical: 6px, Horizontal: 12px)
            py: '6px',
            px: '12px',

            // Layout Interno
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            boxSizing: 'border-box',
            backgroundColor: props.backgroundColor,
            borderRadius: '100px',
            border: `2px solid ${props.borderColor}`,
        }}
        onClick={() => props.onClick(props.value)}
        disabled={props.disabled}
    >
        <TypographyComponent
            variant="body2" fontWeight="bold"
            sx={{
                fontFamily: '"Font 1", sans-serif',
                fontWeight: 700,
                fontSize: '11.4px',
                lineHeight: '16px',
                letterSpacing: '0em',

                // Alinhamento Centralizado
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                verticalAlign: 'middle',

                // Estética
                textTransform: 'none',
                // width: '100%',
                color: props.color,
            }}
        >
            {props.label}
        </TypographyComponent>
        <TypographyComponent
            variant="body2" fontWeight="bold"
            sx={{
                // Tipografia (Font 1 + Bold)
                fontFamily: '"Font 1", sans-serif',
                fontWeight: 700,
                fontSize: '11.8px',
                lineHeight: '16px',
                letterSpacing: '0em',

                // Alinhamento
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                verticalAlign: 'middle',

                // Estética
                textTransform: 'none',
                // width: '100%',
                color: props.color
            }}
        >
            {props.count}
        </TypographyComponent>
    </ButtonComponent>
}

export default ButtonFilterPedidoComponent;